import {otsBaseApi} from "../../ots-api";
import {EntityIdentifier} from "../../../model/entity";
import {IntegrationHistory, ObjectIntegrationStatus} from "../../../model/integration-history";

const taggedBaseApi = otsBaseApi.enhanceEndpoints({addTagTypes: ['IntegrationStatuses', 'IntegrationHistories']})

const integrationHistoryApi = taggedBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    getIntegrationStatusByObject: builder.query<ObjectIntegrationStatus, EntityIdentifier>({
        query: (eo) => ({
          url: '/integration/entity/status',
          method: 'GET',
          params: {entityId: eo.id, entityType: eo.type},
        }),
        providesTags: (result, error, arg) => {
          return [{type: 'IntegrationStatuses', id: arg.id}];
        },
      }
    ),
    getIntegrationHistoryByObject: builder.query<IntegrationHistory[], EntityIdentifier>({
        query: (eo) => ({
          url: '/integration/entity/history',
          method: 'GET',
          params: {entityId: eo.id, entityType: eo.type},
        }),
        providesTags: (result, error, arg) => {
          return [{type: 'IntegrationHistories', id: arg.id}];
        },
      }
    ),
  }),
})

export const {
  useGetIntegrationStatusByObjectQuery,
  useGetIntegrationHistoryByObjectQuery,
} = integrationHistoryApi;
